module.exports = __webpack_public_path__ + "img/attendee_add.eeb4d63c.png";